module.exports = __webpack_public_path__ + "static/img/jianshiClick.2a02822.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/jianshiClick.png
// module id = rV4b
// module chunks = 0